import MiddleBanner from "../middle-banner/middle-banner.vue";
import { mediaQuery } from "../../mixins/media-query";
import { gtagMixin } from "../../mixins/gtag-mixin";
import { contentfulMixin } from "../../mixins/contentful";

export default {
  mixins: [mediaQuery, gtagMixin, contentfulMixin],
  components: { MiddleBanner },
  props: ["idNav"],

  mounted() {
    this.getOpenPositions();
  },
};
